import React, {Component} from 'react';

function withError(WrappedComponent) {
  return class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        error: null
      };

      this.handleSetError = this.handleSetError.bind(this);
    }

    handleSetError(error) {
      this.setState({
        error: error
      });
    }

    render() {
      if (this.state.error) {
        throw this.state.error;
      }

      return <WrappedComponent setError={this.handleSetError} {...this.props}/>;
    }
  };
}

export default withError;
